<template>
 <div class="app-container">
   <div class="formBox margbot" ref="searchBox">
      <el-form :inline="true" :model="searchFrom"  class="demo-form-inline" label-width="110px" size="mini">
        <div class="formItemBox">
           <el-form-item label="子公司:">
            <el-select  v-model="searchFrom.remark" filterable placeholder="请选择" @change="zigsChangeCX">
              <el-option v-for="item in zigsList" :label="item.companyName" :value="item.companyCode" :key="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="业务部门:">
            <el-select  v-model="searchFrom.itemNo" filterable placeholder="请选择">
              <el-option v-for="item in bumenList" :label="item.name" :value="item.code" :key="item.id"></el-option>
            </el-select>
          </el-form-item>
        </div>
       <div class="searchBtnBox">
         <el-form-item  v-if="btnFlg[0]">
            <el-button type="primary" @click="getList(searchFrom)">查询</el-button>
          </el-form-item>
          <el-form-item  v-if="btnFlg[1]">
            <el-button type="primary" @click="resetForm">重置</el-button>
          </el-form-item>
          <el-form-item  v-if="btnFlg[2]"  >
            <el-button type="primary"  @click="addRegion">新增</el-button>
          </el-form-item>
       </div>
      </el-form>
    </div>
    <!--  表格 -->
    <div class="table" :style="{height:h}">
      <el-table :data="tableList"  ref="table" v-loading="loading"   bordersize="mini"  @selection-change='selectGoods'
       @row-click="handleRowClick"  style="width: 100%" height="100%"  center border  class="tableComent">
      <!-- <el-table-column type="selection" width="55"></el-table-column> -->
        <el-table-column type="index" prop="date" width="55" label="序号"></el-table-column>
         <el-table-column label="操作"  width="120">
            <template slot-scope="scope">
              <el-button type="text" size="mini"  v-if="btnFlg[3]"  @click="modifyRegion(scope.row)">修改</el-button>
               <el-button type="text" size="mini" v-if="btnFlg[4]"  @click="delDeiver(scope.row)">删除</el-button>

            </template>
        </el-table-column>
        <el-table-column prop="ext3" min-width="300"  :formatter="emptyFn" label="子公司"></el-table-column>
        <el-table-column prop="showName" min-width="300"  :formatter="emptyFn" label="部门"></el-table-column>
        <el-table-column prop="ext1" min-width="100"  :formatter="emptyFn" label="年份"></el-table-column>
        <el-table-column prop="ext2" width="150" :formatter="emptyFn" label="资金占用年利率(%)"></el-table-column>
        <el-table-column prop="createUser" min-width="120" :formatter="emptyFn" label="创建人"></el-table-column>
        <el-table-column prop="createTime" min-width="170" :formatter="dateTimeFormat"  label="创建时间"></el-table-column>
      </el-table>
    </div>
     <!-- 分页 -->
    <div>
      <el-pagination background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="searchFrom.pageNo"
        :page-sizes="[20,50,100]"
        :page-size="searchFrom.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>
    <!-- 新建修改 -->
    <el-dialog  :title="isAdd?'添加':'修改'"  :close-on-click-modal="false" :close-on-press-escape="false" class="jiaoyan" @close="closeDialog"   :visible.sync="dialogVisible" width="400px" center>
      <span>
         <el-form :inline="true" :rules="rules" :model="addFrom" ref="addFrom" class="demo-form-inline" label-width="130px" size="mini">
        <div class="inpBox">
          <el-form-item label="子公司:" prop="itemNo" >
            <el-select  v-model="addFrom.remark" filterable placeholder="请选择" @change="zigsChange" >
              <el-option v-for="item in zigsList" :label="item.companyName" :value="item.companyCode" :key="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="部门名称:" prop="itemNo" >
            <el-select  v-model="addFrom.itemNo" filterable placeholder="请选择" >
              <el-option v-for="item in bumenList" :label="item.name" :value="item.code" :key="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="年份" prop="ext1"  >
            <el-date-picker  v-model="addFrom.ext1"  type="year"  value-format="yyyy"  placeholder="选择年"></el-date-picker>
          </el-form-item>
          <el-form-item label="资金占用年利率" prop="ext2" class="jiage" >
              <el-input  placeholder="" maxlength="5" v-number-input.float="2"  v-model.trim="addFrom.ext2"  ></el-input>
              <span class="danwei">%</span>
          </el-form-item>
        </div>
        </el-form>
      </span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="saveFn('addFrom')">确 定</el-button>
      </span>
    </el-dialog>
 </div>
</template>

<script>
import { getBtn } from '@/utils/getButton'
import { getDictionaryDetailList, addOrUpFinancialSettings } from '@/api/newTMS'
import { getCurrUserDepartment, getCurrUserCompany } from '@/api/newCrm'
import { emptyFn, dateTimeFormat } from '@/utils/util'
export default {
  components: {

  },
  data () {
    return {
      isAdd: false,
      h: 500,
      emptyFn: emptyFn,
      dateTimeFormat: dateTimeFormat,
      title: '新增',
      dialogVisible: false,
      bumenList: [],
      zigsList: [], // 子公司列表
      tableList: [],
      searchFrom: {
        pageNo: 1,
        pageSize: 50,
        dictionaryType: 'financial_settings'
      },
      total: 0,
      loading: 'false',
      rules: {
        itemNo: [
          { required: true, message: '请选择部门名称', trigger: 'blur' }
        ],
        ext1: [
          { required: true, message: '请选择年份', trigger: 'blur' }
        ],
        ext2: [
          { required: true, message: '请输入资金占用年利率', trigger: 'blur' }
        ]

      },
      addFrom: {},
      btnFlg: [],
      btnIdArr: ['01N00V0100', '01N00V0200', '01N00V0300', '01N00V0400', '01N00V0500']
    }
  },
  created () {
    this.btnFlg = getBtn(this.btnIdArr)
    getCurrUserCompany().then(res => { this.zigsList = res })
    this.getList(this.searchFrom)
  },
  mounted () {
    let h = this.$refs.searchBox.offsetHeight
    let pH = document.documentElement.clientHeight
    this.h = (pH - h - 168) + 'px'
  },
  methods: {
    // 选择数据
    selectGoods (selection) {

    },
    // 点击选中
    handleRowClick (row, column, event) {
      this.$refs.table.toggleRowSelection(row)
    },
    // 获取列表
    getList (searchFrom) {
      this.loading = true
      this.searchFrom.masterId = this.masterId
      getDictionaryDetailList(searchFrom).then(res => {
        this.loading = false
        this.tableList = res.list
        this.total = res.total
      })
    },
    // 每页条数
    handleSizeChange (val) {
      this.searchFrom.pageSize = val
      this.getList(this.searchFrom)
    },
    // 当前页
    handleCurrentChange (val) {
      this.searchFrom.pageNo = val
      this.getList(this.searchFrom)
    },
    // 子公司更改
    zigsChange (e) {
      let json1 = this.zigsList.filter(item => item.companyCode == e)
      this.$set(this.addFrom, 'ext3', json1[0].companyName)
      getCurrUserDepartment({ compayCode: e }).then(res => { this.bumenList = res })
      this.$set(this.addFrom, 'itemNo', '')
      this.$set(this.addFrom, 'showName', '')
    },
    // 子公司更改
    zigsChangeCX (e) {
      getCurrUserDepartment({ compayCode: e }).then(res => { this.bumenList = res })
      this.$set(this.searchFrom, 'itemNo', '')
    },
    // 添加
    addRegion () {
      this.title = '新增'
      this.addFrom = {}
      this.dialogVisible = true
      this.addFrom.dictionaryType = 'financial_settings'
      this.addFrom.dictionaryName = '财务设置'
      this.addFrom.orderBy = 1
      this.isAdd = true
    },
    // 修改
    modifyRegion (row) {
      this.addFrom = JSON.parse(JSON.stringify(row))
      getCurrUserDepartment({ compayCode: this.addFrom.remark }).then(res => { this.bumenList = res })
      this.title = '修改'
      this.dialogVisible = true
      this.isAdd = false
      this.flag = true
    },
    saveFn (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let json1 = this.bumenList.filter(item => item.code == this.addFrom.itemNo)
          this.$set(this.addFrom, 'showName', json1[0].name)
          const loading = this.$loading({
            lock: true,
            text: '正在处理...'
          })
          addOrUpFinancialSettings(this.addFrom).then(res => {
            loading.close()
            this.$message({
              message: '添加成功',
              type: 'success'
            })
            this.dialogVisible = false
            this.getList(this.searchFrom)
          }).catch(error => {
            this.$message({
              showClose: true,
              message: error.message,
              type: 'error',
              onClose () {
                loading.close()
              }
            })
          })
        } else {
          return false
        }
      })
    },

    // 删除
    delDeiver (row) {
      this.$confirm('是否执行删除操作?', '系统提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(() => {
        const loading = this.$loading({
          lock: true,
          text: '正在处理...'
        })
        addOrUpFinancialSettings({ detailId: row.detailId, delFlag: 1 }).then(res => {
          loading.close()
          this.$message({
            message: '删除成功',
            type: 'success'
          })
          this.getList(this.searchFrom)
        }).catch(error => {
          this.$message({
            showClose: true,
            message: error.message,
            type: 'error',
            onClose () {
              loading.close()
            }
          })
        })
      }).catch(() => {

      })
    },
    closeDialog () {
      this.addFrom = {}
      this.$refs.table.clearSelection()
      this.$refs.addFrom.clearValidate()
      this.flag = false
    },
    // 重置
    resetForm (formName) {
      this.searchFrom = {
        pageNo: 1,
        pageSize: 50,
        dictionaryType: 'financial_settings'
      }
    }
  }
}
</script>

<style scoped lang='less'>
.searchBtnBox {
  margin-left: 10px;
}
.inpBox /deep/.el-input__inner{
  width: 178px;
}
 /deep/.el-form {
  width: 100%;
 }
</style>
